import { ChargeFormFieldValues } from "../types";

/**
 * The `liveFields` manifest — the single, reviewable ledger of which fields the
 * new charge form currently *owns* (makes editable and takes from user input).
 *
 * Every other field is disabled pass-through: shown to the user seeded from the
 * loaded charge, locked, and carried through the save unchanged. Advancing the
 * rebuild one field-cluster at a time is *one edit to this set*.
 *
 * TEMPORARY: this manifest exists only while the old form and the new form
 * coexist. When the new form fully replaces the old one, delete the manifest
 * and the pass-through wrapper that consults it (layer C in design.md D3).
 */
export type FieldName = keyof ChargeFormFieldValues;

export const liveFields: Set<FieldName> = new Set<FieldName>([
  "notes",
  "editNotes",
  "billable",
  "taxable",
  "eeCode",
  "rateAmount",
  "employee",
  "date",
  "project",
  "useCustomRate",
  "rate",
  "unit",
  "quantity",
  "customRateLabel",
]);

export const isLiveField = (field: FieldName): boolean => liveFields.has(field);
